import { render, staticRenderFns } from "./MaterialCategoryList.vue?vue&type=template&id=39f7734c&"
import script from "./MaterialCategoryList.js?vue&type=script&lang=js&"
export * from "./MaterialCategoryList.js?vue&type=script&lang=js&"
import style0 from "./MaterialCategoryList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports